<template>
	<b-container id="topContainer">
		<div v-if="!isMigrationDataLoaded"
				 class="background-white d-block text-center" style="margin-bottom: 20px !important;">
			<b-spinner variant="primary" class="spinner-custom"></b-spinner>
			<div style="margin: 30px 0;">
				<p class="error-title">{{ $t('loadingTitle') }}</p>
				<p class="error-title error-desc">{{ $t('loadingDesc') }}</p>
			</div>
		</div>

		<div v-if="isMigrationDataLoaded && !dataError && isRelevantUseCase">

			<div id="migrationSection">
				<div v-if="existsCaBenefits.length > 0" class="m1_wrapper">
					<img class="m1_icon" src="../assets/images/figma/hand_star.svg"/>
					<div class="m1_text_wrapper">
						<div class="m1_nadpis">
							{{ $t('benefitsCaTitle') }}
						</div>
						<div class="m1_text">
							{{ $t('benefitsCaDesc') }}
						</div>
					</div>
					<div class="placeholder"></div>
					<div class="ca_list_wrapper">
						<div class="ca_list">
							<div v-for="item in existsCaBenefits" :key="item.description"
									 class="ca_item"><img src="../assets/images/figma/Checkmark.svg"/>
								<span>{{ item.description }}</span>
							</div>
						</div>
					</div>
				</div>

				<div v-if="isMagentaBusiness" class="m1_wrapper">
					<img class="m1_icon" src="../assets/images/figma/magenta_one_badge.svg"/>
					<div class="m1_text_wrapper">
						<div class="m1_nadpis color-magenta">
							{{ $t('benefitsM1Title') }}
						</div>
						<div class="m1_text">
							{{ $t('benefitsM1Desc') }}
						</div>
					</div>
				</div>

				<div v-for="(item, index) in this.$store.state.transformInfoData.slice(0, 4)" :key="item.subscriberId">
					<b-overlay
							:id="'overlay'+index"
							variant="transparent"
							opacity="1"
							blur="2px"
							rounded="sm">
						<div class="background-white" style="margin-bottom: 40px;"
								 :class="!showCurrentTariff ? 'background-white-no-current-tariff' : ''">
							<div class="tarif_nadpis_wrapper">
								<div class="zakaznik_wrapper">
									<img class="zakaznik_icon" src="../assets/images/icons/phone_plne_pozadi.svg"/>
									<div v-if="item.alias === null">
										<div class="zakaznik_name" style="padding-top: 5px;">{{ item.msisdn }}</div>
									</div>
									<div v-else-if="item.alias !== null">
										<div class="zakaznik_name">{{ item.alias }}</div>
										<div class="zakaznik_number">{{ item.msisdn }}</div>
									</div>
								</div>
							</div>
							<!--/* nejprve kouknu jestli nemame nejaky problem */-->
							<div v-if="resolveReconciliationUnqualified(item, index)" class="tarif_nadpis_wrapper" style="border: none; padding-bottom: 0px;">
								<div v-if="item.qualificationResults[0].eligibilityCheckError.code === 'ALREADY_CHANGED_TO_KIWI'">
									<div class="upozorneni_wrapper" style="background-color: #F8FDF3; margin-bottom: 0px; margin-top: 25px;">
										<img class="upozorneni_icon" src="../assets/images/icons/info-ok.svg"/>
										<div>
											<span class="info-msg-title">{{ $t('alreadyChangedTitle') }}</span><br/>
											<span class="info-msg-title info-msg-desc">{{ $t('alreadyChangedDesc') }}</span>
										</div>
									</div>
									<div v-if="!dataLoadedForSubscriber[item.subscriberId]"
											 class="tarif_nadpis_wrapper" style="border: none;">
										<div class="zakaznik_wrapper">
											<b-spinner variant="primary" class="spinner-custom"></b-spinner>
										</div>
									</div>
									<div v-if="dataLoadedForSubscriber[item.subscriberId]">
										<div v-if="item.currentTariff !== null" class="soucasny_tarif_wrapper">
											<div class="tarif_cena">{{ $t('yourNewTitle') }}</div>
											<div class="tarif_data">{{ item.currentTariff.tariffName }}</div>
											<div class="tarif_data_detail_wrapper">

												<div class="detail_polozka">
													<div class="tarif_data_detail_nadpis">
														{{ $t('data') }}
													</div>
													<div class="tarif_data_detail_value">
														<span v-if="item.currentTariff.dataPart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24" height="24" alt="unlimited"></span>
														<span v-if="!item.currentTariff.dataPart.isUnlimited">{{ resolveDataPart(item.currentTariff.dataPart) }}</span>
													</div>
												</div>

												<div class="detail_polozka">
													<div class="tarif_data_detail_nadpis">
														{{ $t('minutesAndSms') }}
													</div>
													<div class="tarif_data_detail_value">
										<span v-if="item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24"
																																																												 height="24" alt="unlimited"></span>
														<span v-if="!(item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited)">{{ resolveVoiceSmsPart(item.currentTariff) }}</span>
													</div>
												</div>
											</div>
											<div class="tarif_cena">{{ item.currentTariff.pricePart.finalPriceIncludedAmount }} {{ $t('czk') }}</div>
											<div class="tarif_cena_obdobi">{{ $t('monthly') }}</div>
										</div>
									</div>
								</div>
								<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'PREPAID_SERVICE'"
										 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 25px; display: block;">
									<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
									<div style="display: grid;">
										<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginTwistTitle') }}</span>
										<span class="info-msg-title info-msg-desc" v-html="$t('loginTwistDesc')">
									</span>
									</div>
									<eshopLink v-bind:text-link="$t('loginTwistCta')" v-bind:link-name="'eshopLink'"></eshopLink>
								</div>
								<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'MIGRATION_DATE_IN_THE_PAST'"
										 class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 25px; display: block;">
									<img class="upozorneni_icon" src="../assets/images/icons/warning_big.svg"/>
									<div style="display: grid;">
										<span class="info-msg-title info-msg-desc">
										{{ $t('migrationInThePastDesc') }}
									</span>
									</div>
								</div>
								<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'LESANA_AND_TECHNICAL_PRODUCT_MISSING'"
										 class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 25px; display: block;">
									<img class="upozorneni_icon" src="../assets/images/icons/warning_big.svg"/>
									<div style="display: grid;">
										<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('lesanaTechnicalProductMissingTitle') }}</span>
										<span class="info-msg-title info-msg-desc">
											{{ $t('lesanaTechnicalProductMissingDesc') }}
										</span>
									</div>
								</div>
								<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'NON_MOBILE_VOICE_SERVICE'"
										 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 25px; display: block;">
									<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
									<div style="display: grid;">
										<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginFixTitle') }}</span>
										<span class="info-msg-title info-msg-desc" v-html="$t('loginFixDesc')">
										</span>
									</div>
									<eshopLink v-bind:text-link="$t('loginFixCta')" v-bind:link-name="'eshopLink'"></eshopLink>
								</div>
								<div v-else
										 class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 25px; display: block;">
									<!-- TECHNICAL_PRODUCT_MISSING-->
									<img class="upozorneni_icon" src="../assets/images/icons/pending_big.svg"/>
									<div style="display: grid;">
										<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('waitingCaseTitle') }}</span>
										<span class="info-msg-title info-msg-desc">{{ $t('waitingCaseDesc') }}</span>
									</div>
								</div>
							</div>
							<!--/* Popripade loading pro data */-->
							<div v-else-if="resolveReconciliationQualified(item, index) && !dataLoadedForSubscriber[item.subscriberId]"
									 class="tarif_nadpis_wrapper" style="border: none;">
								<div class="zakaznik_wrapper">
									<b-spinner variant="primary" class="spinner-custom"></b-spinner>
								</div>
							</div>
							<!--/* a dataaaaaa */-->
							<div v-else-if="resolveReconciliationQualified(item, index) && dataLoadedForSubscriber[item.subscriberId]" class="tarify_super_wrapper"
									 :class="!showCurrentTariff ? 'tarify_super_wrapper-no-current-tariff' : ''">
								<div v-if="showCurrentTariff" class="soucasny_tarif_wrapper tarif_wrapper">
									<div class="tarif_name">{{ $t('currentTariff') }}</div>
									<div class="tarif_data" :id="'soucasny_tarif_el'+index">{{ item.currentTariff.tariffName }}</div>
									<div class="tarif_data_detail_wrapper">

										<div class="detail_polozka">
											<div class="tarif_data_detail_nadpis">
												{{ $t('data') }}
											</div>
											<div class="tarif_data_detail_value">
												<span v-if="item.currentTariff.dataPart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24" height="24" alt="unlimited"></span>
												<span v-if="!item.currentTariff.dataPart.isUnlimited">{{ resolveDataPart(item.currentTariff.dataPart) }}</span>
											</div>
										</div>

										<div class="detail_polozka">
											<div class="tarif_data_detail_nadpis">
												{{ $t('minutesAndSms') }}
											</div>
											<div class="tarif_data_detail_value">
										<span v-if="item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24"
																																																												 height="24" alt="unlimited"></span>
												<span v-if="!(item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited)">{{ resolveVoiceSmsPart(item.currentTariff) }}</span>
											</div>
										</div>
									</div>
									<div v-if="showPrice" class="tarif_cena">{{ item.currentTariff.pricePart.finalPriceIncludedAmount }} {{ $t('czk') }}</div>
									<div v-if="showPrice" class="tarif_cena_obdobi">{{ $t('monthly') }}</div>
								</div>
								<img v-if="showCurrentTariff" class="arrow_icon" src="../assets/images/figma/Arrow-right.svg"/>

								<div v-if="item.newTariffDetail !== null" class="novy_tarif_wrapper tarif_wrapper">

									<div class="tarif_name">{{ $t('newTariff') }}</div>
									<div class="tarif_data" :id="'novy_tarif_el'+index">{{ item.newTariffDetail.tariffName }}</div>
									<div class="tarif_data_detail_wrapper">

										<div class="detail_polozka">
											<div class="tarif_data_detail_nadpis">
												{{ $t('data') }}
											</div>
											<div class="tarif_data_detail_value">
												<span v-if="item.newTariffDetail.dataPart.isUnlimited"><img src="../assets/images/infinity_blue.svg" width="24" height="24" alt="unlimited"></span>
												<span v-if="!item.newTariffDetail.dataPart.isUnlimited">{{ resolveDataPart(item.newTariffDetail.dataPart) }}</span>
											</div>
										</div>

										<div class="detail_polozka">
											<div class="tarif_data_detail_nadpis">
												{{ $t('minutesAndSms') }}
											</div>
											<div class="tarif_data_detail_value">
										<span v-if="item.newTariffDetail.smsPart.isUnlimited && item.newTariffDetail.voicePart.isUnlimited"><img src="../assets/images/infinity_blue.svg" width="24"
																																																														 height="24" alt="unlimited"></span>
												<span v-if="!(item.newTariffDetail.smsPart.isUnlimited && item.newTariffDetail.voicePart.isUnlimited)">{{
														resolveVoiceSmsPart(item.newTariffDetail)
													}}</span>
											</div>
										</div>
									</div>

									<div class="tarif_cena">{{ item.newTariffDetail.pricePart.finalPriceIncludedAmount }} {{ $t('czk') }}</div>
									<div class="tarif_cena_obdobi">{{ $t('monthly') }}</div>


									<div v-if="getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).length > 0"
											 class="extra_benefity_wrapper">
										<div class="extra_benefity">
											<div class="benefity_nadpis">
												<img src="../assets/images/figma/icon_gift.svg" class="benefity_nadpis_icon"/>
												<span>{{ $t('extraBenefitsTitle') }}</span>
											</div>
											<div v-for="(benefit, iter) in getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).slice(0,3)"
													 :key="index+'_'+iter"
													 class="benefity_polozka">
												{{ benefit.description }}
											</div>
											<div v-if="getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).length > 3" style="margin-bottom: 15px;">
												<a v-on:click="showMoreBenefits(index)" class="link box-link" style="font-size: 14px; line-height: 20px; cursor: pointer;">{{ $t('extraBenefitsNext') }}
													<b-icon :id="'accordionBenefits-'+index+'-down'" icon="chevron-down" font-scale="1" style="color: #007FAF;" class="show"></b-icon>
													<b-icon :id="'accordionBenefits-'+index+'-up'" icon="chevron-up" font-scale="1" style="color: #007FAF;" class="hide"></b-icon>
												</a>
												<div :id="'accordionBenefits-'+index+'-section'" class="hide" style="margin-top: 15px;">
													<div v-for="(benefit, iter) in getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).slice(3, 10)"
															 :key="index+'_'+iter" class="benefity_polozka">
														{{ benefit.description }}
													</div>
												</div>
											</div>
										</div>
									</div>

								</div>
								<div v-else class="novy_tarif_wrapper">
									<div class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 25px; display: block">
										<img class="upozorneni_icon" src="../assets/images/icons/circle-close.svg" width="56" height="56"/>
										<div style="display: grid;">
											<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('newTariffFailedTitle') }}</span>
											<span class="info-msg-title info-msg-desc">{{ $t('newTariffFailedDesc') }}</span>
										</div>
									</div>
								</div>

								<div v-if="item.newTariffDetail !== null" class="upozorneni_wrapper">
									<img class="upozorneni_icon" src="../assets/images/icons/warning.svg"/>
									<div v-if="item.qualificationResults[0].eligibilityCheckError !== null && item.qualificationResults[0].eligibilityCheckError.code === 'RESTRICTED_USER_ROLE'"
											 class="upozorneni_text" v-html="$t('restrictedWarningText', { endDate: item.endDate})">
									</div>
									<div
											v-else-if="item.qualificationResults[0].eligibilityCheckError !== null && item.qualificationResults[0].eligibilityCheckError.code === 'MIGRATION_DATE_IN_THE_PAST'"
											class="upozorneni_text" v-html="$t('migrationWarningText', { endDate: item.endDate})">
									</div>
									<div v-else-if="item.qualificationResults[0].eligibilityCheckError !== null && item.qualificationResults[0].eligibilityCheckError.code === 'SUSPENDED_SERVICE'"
											 class="upozorneni_text" v-html="$t('suspendWarningText', { endDate: item.endDate})">
									</div>
									<div v-else class="upozorneni_text" v-html="$t('commonWarningText', { endDate: item.endDate})">
									</div>
								</div>
								<div v-if="!resolveTariffQualified(item) && item.qualificationResults[0].eligibilityCheckError.code === 'RESTRICTED_USER_ROLE'"
										 class="upozorneni_wrapper" style="background-color: #F1F9FF; margin-bottom: 0px; margin-top: 0px;">
									<img class="upozorneni_icon" src="../assets/images/icons/info_blue.svg"/>
									<div class="upozorneni_text">
										{{ $t('restrictedInfoText') }}
									</div>
								</div>
								<div v-else-if="item.newTariffDetail !== null && item.qualificationResults[0].eligibilityCheckError === null" style="display: contents;">
									<button v-on:click="openModal(item, index)"
													:class="resolveTariffQualified(item) ? 'btn_app btn prave_tlacitko prave_tlacitko_fix' : 'btn_app btn prave_tlacitko prave_tlacitko_fix disabled'">
										{{ $t('changeTariffNowCta') }}
									</button>
								</div>
							</div>
						</div>
					</b-overlay>
				</div>

				<div v-if="this.getAllRecords() > 4">
					<div style="margin-bottom: 40px;">
						<p class="next-su-title">{{ $t('nextSubscribersTitle') }}</p>
						<p class="next-su-desc">{{ $t('nextSubscribersDesc') }}</p>
					</div>
					<div class="background-white" style="grid-template-columns: auto; padding-top: 30px; padding-bottom: 30px;">

						<div v-for="(item, index) in this.$store.state.transformInfoData.slice(4, totalOtherTariffs)" :key="item.subscriberId+'_'+(index+4)"
								 :style="(index+4) > 4 ? 'margin-top: 25px; cursor: pointer;' : 'cursor: pointer;'">

							<div class="tarif_nadpis_wrapper"
									 :style="(index+4) === totalOtherTariffs ? 'border-bottom: none; padding-bottom: 0px;' : 'border-bottom: none;'">
								<div v-on:click="clickCollapseOtherTariff(index+4)"
										 class="zakaznik_wrapper" style="grid-template-columns: 50px 185px 25px 1fr; align-items: baseline;">
									<img class="zakaznik_icon" src="../assets/images/icons/phone_plne_pozadi.svg"/>
									<div v-if="item.alias === null">
										<div class="zakaznik_name" style="padding-top: 5px;">{{ item.msisdn }}</div>
									</div>
									<div v-else-if="item.alias !== null">
										<div class="zakaznik_name">{{ item.alias }}</div>
										<div class="zakaznik_number">{{ item.msisdn }}</div>
									</div>
									<img :id="'icon-ok-'+(index+4)" :class="resolveOkIcon(item)" src="../assets/images/icons/result_ok_small.svg" width="16" height="16"/>
									<img :id="'icon-pending-'+(index+4)" :class="resolveBadIcon(item)" src="../assets/images/icons/pending_small.svg" width="16" height="16"/>
									<div style="padding-top: 8px;">
										<b-icon :id="'accordion-'+(index+4)+'-down'" icon="chevron-down" font-scale="1" style="color: #262626;" class="show"></b-icon>
										<b-icon :id="'accordion-'+(index+4)+'-up'" icon="chevron-up" font-scale="1" style="color: #262626;" class="hide"></b-icon>
									</div>
								</div>
							</div>
							<div v-if="(index+4) !== (totalOtherTariffs - 1)" :id="'otherTariffSplitter_'+(index+4)" class="splitter"></div>
							<div :id="'otherTariff_'+(index+4)" class="hide other-tariffs-section"
									 :class="!showCurrentTariff ? 'fix-no-tariff-grid' : ''"
									 :style="(index+5) === totalOtherTariffs ? 'border-bottom: none;' : ''">
								<!--/* nejprve kouknu jestli nemame nejaky problem */-->
								<div v-if="resolveReconciliationUnqualified(item, index+4)" class="tarif_nadpis_wrapper" style="border: none; padding-bottom: 0px;">
									<div v-if="item.qualificationResults[0].eligibilityCheckError.code === 'ALREADY_CHANGED_TO_KIWI'">
										<div class="upozorneni_wrapper" style="background-color: #F8FDF3; margin-bottom: 0px;">
											<img class="upozorneni_icon" src="../assets/images/icons/info-ok.svg"/>
											<div>
												<span class="info-msg-title">{{ $t('alreadyChangedTitle') }}</span><br/>
												<span class="info-msg-title info-msg-desc">{{ $t('alreadyChangedDesc') }}</span>
											</div>
										</div>
										<div v-if="!dataLoadedForSubscriber[item.subscriberId]"
												 class="tarif_nadpis_wrapper" style="border: none;">
											<div class="zakaznik_wrapper">
												<b-spinner variant="primary" class="spinner-custom"></b-spinner>
											</div>
										</div>
										<div v-if="dataLoadedForSubscriber[item.subscriberId]">
											<div v-if="item.currentTariff !== null" class="soucasny_tarif_wrapper">
												<div class="tarif_cena">{{ $t('yourNewTitle') }}</div>
												<div class="tarif_data">{{ item.currentTariff.tariffName }}</div>
												<div class="tarif_data_detail_wrapper">

													<div class="detail_polozka">
														<div class="tarif_data_detail_nadpis">
															{{ $t('data') }}
														</div>
														<div class="tarif_data_detail_value">
															<span v-if="item.currentTariff.dataPart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24" height="24" alt="unlimited"></span>
															<span v-if="!item.currentTariff.dataPart.isUnlimited">{{ resolveDataPart(item.currentTariff.dataPart) }}</span>
														</div>
													</div>

													<div class="detail_polozka">
														<div class="tarif_data_detail_nadpis">
															{{ $t('minutesAndSms') }}
														</div>
														<div class="tarif_data_detail_value">
										<span v-if="item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24"
																																																												 height="24" alt="unlimited"></span>
															<span v-if="!(item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited)">{{
																	resolveVoiceSmsPart(item.currentTariff)
																}}</span>
														</div>
													</div>
												</div>
												<div class="tarif_cena">{{ item.currentTariff.pricePart.finalPriceIncludedAmount }} {{ $t('czk') }}</div>
												<div class="tarif_cena_obdobi">{{ $t('monthly') }}</div>
											</div>
										</div>
									</div>
									<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'PREPAID_SERVICE'"
											 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
										<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
										<div style="display: grid;">
											<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginTwistTitle') }}</span>
											<span class="info-msg-title info-msg-desc" v-html="$t('loginTwistDesc')">
									</span>
										</div>
										<eshopLink v-bind:text-link="$t('loginTwistCta')" v-bind:link-name="'eshopLink'"></eshopLink>
									</div>
									<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'MIGRATION_DATE_IN_THE_PAST'"
											 class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
										<img class="upozorneni_icon" src="../assets/images/icons/warning_big.svg"/>
										<div style="display: grid;">
											<span class="info-msg-title info-msg-desc">
										{{ $t('migrationInThePastDesc') }}
									</span>
										</div>
									</div>
									<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'LESANA_AND_TECHNICAL_PRODUCT_MISSING'"
											 class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
										<img class="upozorneni_icon" src="../assets/images/icons/warning_big.svg"/>
										<div style="display: grid;">
											<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('lesanaTechnicalProductMissingTitle') }}</span>
											<span class="info-msg-title info-msg-desc">
										{{ $t('lesanaTechnicalProductMissingDesc') }}
									</span>
										</div>
									</div>
									<div v-else-if="item.qualificationResults[0].eligibilityCheckError.code === 'NON_MOBILE_VOICE_SERVICE'"
											 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
										<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
										<div style="display: grid;">
											<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginFixTitle') }}</span>
											<span class="info-msg-title info-msg-desc" v-html="$t('loginFixDesc')">
										</span>
										</div>
										<eshopLink v-bind:text-link="$t('loginFixCta')" v-bind:link-name="'eshopLink'"></eshopLink>
									</div>
									<div v-else
											 class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
										<!-- TECHNICAL_PRODUCT_MISSING-->
										<img class="upozorneni_icon" src="../assets/images/icons/pending_big.svg"/>
										<div style="display: grid;">
											<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('waitingCaseTitle') }}</span>
											<span class="info-msg-title info-msg-desc">
												{{ $t('waitingCaseDesc') }}
												</span>
										</div>
									</div>
								</div>
								<!--/* Popripade loading pro data */-->
								<div v-else-if="resolveReconciliationQualified(item, (index+4)) && !dataLoadedForSubscriber[item.subscriberId]"
										 class="tarif_nadpis_wrapper" style="border: none;">
									<div class="zakaznik_wrapper">
										<b-spinner variant="primary" class="spinner-custom"></b-spinner>
									</div>
								</div>
								<!--/* a dataaaaaa */-->
								<div v-else-if="resolveReconciliationQualified(item, (index+4)) && dataLoadedForSubscriber[item.subscriberId]" class="tarify_super_wrapper"
										 :class="!showCurrentTariff ? 'tarify_super_wrapper-no-current-tariff' : ''">
									<div v-if="showCurrentTariff" class="soucasny_tarif_wrapper tarif_wrapper">
										<div class="tarif_name">{{ $t('currentTariff') }}</div>
										<div class="tarif_data soucasny_tarif_el">{{ item.currentTariff.tariffName }}</div>
										<div class="tarif_data_detail_wrapper">

											<div class="detail_polozka">
												<div class="tarif_data_detail_nadpis">
													{{ $t('data') }}
												</div>
												<div class="tarif_data_detail_value">
													<span v-if="item.currentTariff.dataPart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24" height="24" alt="unlimited"></span>
													<span v-if="!item.currentTariff.dataPart.isUnlimited">{{ resolveDataPart(item.currentTariff.dataPart) }}</span>
												</div>
											</div>

											<div class="detail_polozka">
												<div class="tarif_data_detail_nadpis">
													{{ $t('minutesAndSms') }}
												</div>
												<div class="tarif_data_detail_value">
											<span v-if="item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited"><img src="../assets/images/infinity_gray.svg" width="24"
																																																													 height="24" alt="unlimited"></span>
													<span v-if="!(item.currentTariff.smsPart.isUnlimited && item.currentTariff.voicePart.isUnlimited)">{{ resolveVoiceSmsPart(item.currentTariff) }}</span>
												</div>
											</div>
										</div>
										<div v-if="showPrice" class="tarif_cena">{{ item.currentTariff.pricePart.finalPriceIncludedAmount }} {{ $t('czk') }}</div>
										<div v-if="showPrice" class="tarif_cena_obdobi">{{ $t('monthly') }}</div>
									</div>
									<img v-if="showCurrentTariff" class="arrow_icon" src="../assets/images/figma/Arrow-right.svg"/>

									<div v-if="item.newTariffDetail !== null" class="novy_tarif_wrapper tarif_wrapper"
											 :class="!showCurrentTariff ? 'novy_tarif_wrapper-fix' : ''">

										<div class="tarif_name">{{ $t('newTariff') }}</div>
										<div class="tarif_data novy_tarif_el">{{ item.newTariffDetail.tariffName }}</div>
										<div class="tarif_data_detail_wrapper">

											<div class="detail_polozka">
												<div class="tarif_data_detail_nadpis">
													{{ $t('data') }}
												</div>
												<div class="tarif_data_detail_value">
													<span v-if="item.newTariffDetail.dataPart.isUnlimited"><img src="../assets/images/infinity_blue.svg" width="24" height="24" alt="unlimited"></span>
													<span v-if="!item.newTariffDetail.dataPart.isUnlimited">{{ resolveDataPart(item.newTariffDetail.dataPart) }}</span>
												</div>
											</div>

											<div class="detail_polozka">
												<div class="tarif_data_detail_nadpis">
													{{ $t('minutesAndSms') }}
												</div>
												<div class="tarif_data_detail_value">
											<span v-if="item.newTariffDetail.smsPart.isUnlimited && item.newTariffDetail.voicePart.isUnlimited"><img src="../assets/images/infinity_blue.svg" width="24"
																																																															 height="24" alt="unlimited"></span>
													<span v-if="!(item.newTariffDetail.smsPart.isUnlimited && item.newTariffDetail.voicePart.isUnlimited)">{{
															resolveVoiceSmsPart(item.newTariffDetail)
														}}</span>
												</div>
											</div>
										</div>

										<div class="tarif_cena">{{ item.newTariffDetail.pricePart.finalPriceIncludedAmount }} {{ $t('czk') }}</div>
										<div class="tarif_cena_obdobi">{{ $t('monthly') }}</div>


										<div v-if="getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).length > 0"
												 class="extra_benefity_wrapper">
											<div class="extra_benefity">
												<div class="benefity_nadpis">
													<img src="../assets/images/figma/icon_gift.svg" class="benefity_nadpis_icon"/>
													<span>{{ $t('extraBenefitsTitle') }}</span>
												</div>
												<div v-for="(benefit, iter) in getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).slice(0, 3)"
														 :key="(index+5)+'_'+iter"
														 class="benefity_polozka">
													{{ benefit.description }}
												</div>
												<div v-if="getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).length > 3" style="margin-bottom: 15px;">
													<a v-on:click="showMoreBenefits((index+5))" class="link box-link" style="font-size: 14px; line-height: 20px; cursor: pointer;">{{
															$t('extraBenefitsNext')
														}}
														<b-icon :id="'accordionBenefits-'+(index+5)+'-down'" icon="chevron-down" font-scale="1" style="color: #007FAF;" class="show"></b-icon>
														<b-icon :id="'accordionBenefits-'+(index+5)+'-up'" icon="chevron-up" font-scale="1" style="color: #007FAF;" class="hide"></b-icon>
													</a>
													<div :id="'accordionBenefits-'+(index+5)+'-section'" class="hide" style="margin-top: 15px;">
														<div v-for="(benefit, iter) in getRelevantBenefitsForSu(item.newTariffDetail.migrationBenefits).slice(3, 10)"
																 :key="index+'_'+iter" class="benefity_polozka">
															{{ benefit.description }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-else class="novy_tarif_wrapper"
											 :class="!showCurrentTariff ? 'novy_tarif_wrapper-fix' : ''">
										<div class="upozorneni_wrapper text-center" style="margin-bottom: 0px; margin-top: 25px; display: block">
											<img class="upozorneni_icon" src="../assets/images/icons/circle-close.svg" width="56" height="56"/>
											<div style="display: grid;">
												<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('newTariffFailedTitle') }}</span>
												<span class="info-msg-title info-msg-desc">{{ $t('newTariffFailedDesc') }}</span>
											</div>
										</div>
									</div>


									<div v-if="item.newTariffDetail !== null" class="upozorneni_wrapper">
										<img class="upozorneni_icon" src="../assets/images/icons/warning.svg"/>
										<div v-if="item.qualificationResults[0].eligibilityCheckError !== null && item.qualificationResults[0].eligibilityCheckError.code === 'RESTRICTED_USER_ROLE'"
												 class="upozorneni_text" v-html="$t('restrictedWarningText', { endDate: item.endDate})">
										</div>
										<div
												v-else-if="item.qualificationResults[0].eligibilityCheckError !== null && item.qualificationResults[0].eligibilityCheckError.code === 'MIGRATION_DATE_IN_THE_PAST'"
												class="upozorneni_text" v-html="$t('migrationWarningText', { endDate: item.endDate})">
										</div>
										<div v-else-if="item.qualificationResults[0].eligibilityCheckError !== null && item.qualificationResults[0].eligibilityCheckError.code === 'SUSPENDED_SERVICE'"
												 class="upozorneni_text" v-html="$t('suspendWarningText', { endDate: item.endDate})">
										</div>
										<div v-else class="upozorneni_text" v-html="$t('commonWarningText', { endDate: item.endDate})">
										</div>
									</div>

									<div v-if="!resolveTariffQualified(item) && item.qualificationResults[0].eligibilityCheckError.code === 'RESTRICTED_USER_ROLE'"
											 class="upozorneni_wrapper" style="background-color: #F1F9FF; margin-top: -10px; margin-bottom: 0px;">
										<img class="upozorneni_icon" src="../assets/images/icons/info_blue.svg"/>
										<div class="upozorneni_text">
											{{ $t('restrictedInfoText') }}
										</div>
									</div>
									<div v-else-if="item.newTariffDetail !== null && item.qualificationResults[0].eligibilityCheckError === null" style="display: contents;">
										<button :class="resolveTariffQualified(item) ? 'btn_app btn prave_tlacitko prave_tlacitko_fix' : 'btn_app btn prave_tlacitko prave_tlacitko_fix disabled'">
											{{ $t('changeTariffNowCta') }}
										</button>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<div v-if="showMultiTch" class="dalsi_sluzby_message">
					<div class="d_s_nadpis">{{ $t('confirmAllTitle') }}</div>
					<div class="d_s_text">
						{{ $t('confirmAllDesc') }}
					</div>
					<div class="d_s_button_wrapper">
						<div class="btn_app btn_magenta d_s_button" v-on:click="goToMultiConfrim()">{{ $t('confirmAllCta') }}</div>
					</div>
				</div>
			</div>

			<!-- confirmation part -->
			<div id="confirmationSection" class="hide">
				<confirmationPart/>
			</div>
		</div>

		<div v-if="isMigrationDataLoaded && !dataError && !isRelevantUseCase"
				 class="background-white">
			<div v-if="this.eligibilityCheckErrorReason === 'NOT_ALLOWED_FOR_PREPAID'"
					 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
				<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
				<div style="display: grid;">
					<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginTwistTitle') }}</span>
					<span class="info-msg-title info-msg-desc" v-html="$t('loginTwistDesc')">
					</span>
				</div>
				<eshopLink v-bind:text-link="$t('loginTwistCta')" v-bind:link-name="'eshopLink'"></eshopLink>
			</div>
			<div v-if="this.eligibilityCheckErrorReason === 'NO_MOBILE_VOICE_SERVICE_EXISTS'"
					 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
				<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
				<div style="display: grid;">
					<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginFixTitle') }}</span>
					<span class="info-msg-title info-msg-desc" v-html="$t('loginFixDesc')">
					</span>
				</div>
				<button class="btn_app btn prave_tlacitko prave_tlacitko_fix" style="margin-top: 25px;">
					<eshopLink v-bind:text-link="$t('loginFixCta')" v-bind:link-name="'eshopLink'"></eshopLink>
				</button>
			</div>
			<div v-if="this.eligibilityCheckErrorReason === 'NOT_ALLOWED_FOR_B2B'"
					 class="upozorneni_wrapper upozorneni_wrapper_green text-center" style="margin-bottom: 0px; margin-top: 16px; display: block;">
				<img class="upozorneni_icon" src="../assets/images/icons/result_ok.svg"/>
				<div style="display: grid">
					<span class="info-msg-title" style="margin-top: 20px; margin-bottom: 10px;">{{ $t('loginB2BTitle') }}</span>
					<span class="info-msg-title info-msg-desc">
						{{ $t('loginB2BDesc') }}
					</span>
				</div>
			</div>
		</div>

		<div v-if="isMigrationDataLoaded && dataError"
				 class="background-white d-block text-center">
			<div style="margin: 30px 0;">
				<img style="margin-bottom: 30px;" class="zakaznik_icon" src="../assets/images/icons/circle-close.svg" width="50" height="50"/>
				<p class="error-title">{{ $t('loadingErrorTitle') }}</p>
				<p class="error-title error-desc">{{ $t('loadingErrorDesc') }}</p>
				<button class="btn_app btn prave_tlacitko send-again-btn" v-on:click="tryAgain()">
					{{ $t('loadingErrorCta') }}
				</button>
			</div>
		</div>

		<b-modal :id="infoModal.id" hide-footer hide-header centered
						 :body-bg-variant="infoModal.bodyBgVariant"
						 :body-text-variant="infoModal.bodyTextVariant">
			<div id="modalContent" style="padding: 2rem;">
				<div class="d-block text-center">
					<div style="margin-bottom: 30px;">
						<p class="next-su-title">{{ $t('modalContentTitle') }}</p>
						<p class="next-su-desc" style="margin-top: 25px;" v-html="$t('modalContent', { msisdn: infoModal.msisdn, tariffName: infoModal.content})"></p>
					</div>
				</div>
				<b-row style="align-items: baseline;">
					<b-col class="col-xs-6">
						<button class="btn_app btn leve_tlacitko" @click="resetInfoModal(true)">{{ $t('modalContentCancel') }}</button>
					</b-col>
					<b-col class="col-xs-6">
						<button class="btn_app btn prave_tlacitko" @click="handleOk">{{ $t('modalContentConfirm') }}</button>
					</b-col>
				</b-row>
			</div>
			<div id="modalContentResultError" style="padding: 2rem;" class="hide">
				<div class="d-block text-center">
					<div style="margin-bottom: 50px;">
						<img class="zakaznik_icon" src="../assets/images/icons/result_error.svg" width="50" height="50"/>
						<p class="next-su-title" style="margin-bottom: 20px; margin-top: 18px;">{{ $t('modalContentErrorTitle') }}</p>
						<p class="next-su-desc" v-html="$t('modalContentError', { msisdn: infoModal.msisdn})"></p>
					</div>
					<div style="text-align: -webkit-center;">
						<button class="btn_app btn prave_tlacitko" style="width: 60%" @click="resetInfoModal(false)">{{ $t('modalContentBack') }}</button>
					</div>
				</div>
			</div>
			<div id="modalContentResultOk" style="padding: 2rem;" class="hide">
				<div class="d-block text-center">
					<div style="margin-bottom: 50px;">
						<img class="zakaznik_icon" src="../assets/images/icons/result_ok.svg" width="50" height="50"/>
						<p class="next-su-title" style="margin-bottom: 20px; margin-top: 18px;">{{ $t('modalContentOkTitle') }}!</p>
						<p class="next-su-desc" v-html="$t('modalContentOk', { msisdn: infoModal.msisdn, tariffName: infoModal.content})"></p>
					</div>
					<div style="text-align: -webkit-center;">
						<button class="btn_app btn prave_tlacitko" style="width: 60%" @click="resetData">{{ $t('modalContentOkCta') }}</button>
					</div>
				</div>
			</div>
			<div class="d-block text-center hide" style="padding: 2rem;" id="modalSpinner">
				<b-spinner variant="primary" style="color: #e20074 !important;"></b-spinner>
			</div>
		</b-modal>
	</b-container>
</template>

<script>

import BffAPI from "../service/BffAPI"
import confirmationPart from "../components/ConfirmComponent"
import eshopLink from "../components/EshopLink"

export default {
	name: "ZmenaTarifComponent.vue",
	components: {
		confirmationPart,
		eshopLink
	},
	data: function () {
		return {
			eligibilityCheckErrorLabel: "",
			eligibilityCheckErrorReason: "",
			data: [],
			dataLoadedForSubscriber: {},
			dataStartLoaded: {},
			currentPageOtherTariffs: 14,
			page: 10,
			totalOtherTariffs: 0,
			infoModal: {
				id: 'info-modal',
				content: '',
				msisdn: '',
				bodyBgVariant: 'light',
				bodyTextVariant: 'dark',
				index: null,
				selectedItem: null
			}
		}
	},
	methods: {
		sendCardEvent(id) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'migration_process',
				'tile_type': id
			});
		},
		goToMultiConfrim() {
			// hide overview
			const migrationSection = document.querySelector('#migrationSection')
			migrationSection.classList.add('hide')

			// show confirm
			const confirmSection = document.querySelector('#confirmationSection')
			confirmSection.classList.remove('hide')
			const confirmPart = document.querySelector('#confirmPart')
			confirmPart.classList.remove('hide')

			// hide loading and result
			const resultPart = document.querySelector('#resultPart')
			resultPart.classList.add('hide')

			this.sendCardEvent('click_confirm_all')

			document.getElementById("topContainer").scrollIntoView()
		},
		resolveOkIcon(item) {
			if (item.qualificationResults[0].eligibilityCheckError !== null &&
					(item.qualificationResults[0].eligibilityCheckError.code === 'ALREADY_CHANGED_TO_KIWI'
							|| item.qualificationResults[0].eligibilityCheckError.code === 'PREPAID_SERVICE'
							|| item.qualificationResults[0].eligibilityCheckError.code === 'NON_MOBILE_VOICE_SERVICE')) {
				return 'show'
			} else {
				return 'hide'
			}
		},
		resolveBadIcon(item) {
			if ((item.qualificationResults[0].eligibilityCheckError !== null &&
					(item.qualificationResults[0].eligibilityCheckError.code !== 'ALREADY_CHANGED_TO_KIWI'
							&& item.qualificationResults[0].eligibilityCheckError.code !== 'PREPAID_SERVICE'
							&& item.qualificationResults[0].eligibilityCheckError.code !== 'NON_MOBILE_VOICE_SERVICE')) || item.qualificationResults[0].eligibilityCheckError === null) {
				return 'show'
			} else {
				return 'hide'
			}
		},
		nextPage() {
			this.$store.state.currentPageOtherTariffs = this.$store.state.currentPageOtherTariffs + this.page
		},
		openModal(item, index) {
			if (this.resolveTariffQualified(item)) {
				this.infoModal.content = item.newTariffDetail.tariffName
				this.infoModal.msisdn = item.msisdn
				this.infoModal.index = index
				this.infoModal.selectedItem = item

				let darkmodeMatch = window.matchMedia('(prefers-color-scheme: dark)').matches
				if (darkmodeMatch) {
					const modal = document.querySelector('#' + this.infoModal.id + '___BV_modal_content_')
					if (modal !== null) {
						document.querySelector('#' + this.infoModal.id + '___BV_modal_content_').style.border = "none"
					}
					this.infoModal.bodyTextVariant = 'light'
					this.infoModal.bodyBgVariant = 'dark'
				} else {
					this.infoModal.bodyTextVariant = 'dark'
					this.infoModal.bodyBgVariant = 'light'
				}

				this.sendCardEvent("click_open_popup")

				this.$root.$emit('bv::show::modal', this.infoModal.id)
			}
		},
		handleOk() {
			const modalContent = document.querySelector('#modalContent')
			modalContent.classList.add('hide')
			const modalSpinner = document.querySelector('#modalSpinner')
			modalSpinner.classList.remove('hide')

			const item = this.infoModal.selectedItem

			const prepareBody = [{
				subscriberId: item.subscriberId,
				contactId: item.contactId,
				msisdn: this.formatMsisdnForBff(item.msisdn),
				tariffId: item.newTariffDetail.tariffId,
				validateOnly: false
			}]

			const body = {
				items: prepareBody
			}

			this.sendCardEvent("click_confirm_popup")

			BffAPI.confirmTariffs(this.$store.state.jwt, body)
			.finally(() => this.showResultModal())
		},
		showResultModal() {

			const modalSpinner = document.querySelector('#modalSpinner')
			modalSpinner.classList.add('hide')

			const result = this.$store.state.confirmSimpleStatusInfo

			if (result !== null && "SUBMITTED" === result[0].responseStatus) {
				const modalContentResultOk = document.querySelector('#modalContentResultOk')
				modalContentResultOk.classList.remove("hide")
			} else {
				const modalContentResultError = document.querySelector('#modalContentResultError')
				modalContentResultError.classList.remove("hide")
			}
		},
		resetData() {
			this.tryAgain()
			this.resetInfoModal(false)
			document.getElementById("loginTitle").scrollIntoView()
		},
		tryAgain() {
			this.$store.state.isMigrationDataLoaded = false
			this.$store.state.isBasicInfoDataError = false

			this.$store.state.basicInfoData = null
			this.$store.state.transformInfoData = []
			this.$store.state.confirmSimpleStatusInfo = null
			this.dataLoadedForSubscriber = {}
			this.dataStartLoaded = {}

			this.$store.dispatch('GET_BASIC_INFO', this.$store.state.jwt)
		},
		resetInfoModal(cancel) {
			this.infoModal.content = ''
			this.infoModal.msisdn = ''
			this.infoModal.index = null
			this.infoModal.selectedItem = null

			const modalContent = document.querySelector('#modalContent')
			modalContent.classList.remove('hide')
			const modalSpinner = document.querySelector('#modalSpinner')
			modalSpinner.classList.add('hide')
			const modalContentResultError = document.querySelector('#modalContentResultError')
			modalContentResultError.classList.add("hide")
			const modalContentResultOk = document.querySelector('#modalContentResultOk')
			modalContentResultOk.classList.add("hide")

			this.sendCardEvent(cancel ? "click_cancel_popup" : "click_close_popup")

			this.$root.$emit('bv::hide::modal', this.infoModal.id)
		},
		resolveDataPart(dataPart) {
			if (dataPart.isUnlimited) {
				return this.$t('unlimited')
			} else {

				if (dataPart.value < 1024) {
					return dataPart.value + " MB"
				} else {
					const val = dataPart.value / 1024
					return val + " GB"

				}
			}
		},
		clickCollapseOtherTariff(index) {
			const down = document.getElementById('accordion-' + index + '-down');
			const up = document.getElementById('accordion-' + index + '-up');
			const section = document.getElementById('otherTariff_' + index);
			const splitter = document.getElementById('otherTariffSplitter_' + index);

			if (down.classList !== null && down.classList.contains('show')) {
				// show more
				down.classList.add("hide")
				down.classList.remove("show")
				up.classList.remove("hide")
				up.classList.add("show")
				section.classList.remove("hide")
				section.classList.add("show")
				if (splitter !== null) {
					splitter.classList.remove("show")
					splitter.classList.add("hide")
				}
			} else {
				// show less
				down.classList.remove("hide")
				down.classList.add("show")
				up.classList.add("hide")
				up.classList.remove("show")
				section.classList.remove("show")
				section.classList.add("hide")
				if (splitter !== null) {
					splitter.classList.remove("hide")
					splitter.classList.add("show")
				}
			}

			// hide others
			for (let i = 4; i < this.totalOtherTariffs; i++) {
				if (index === i) {
					continue;
				}
				const down = document.getElementById('accordion-' + i + '-down');
				const up = document.getElementById('accordion-' + i + '-up');
				const section = document.getElementById('otherTariff_' + i);
				const splitter = document.getElementById('otherTariffSplitter_' + i);
				down.classList.remove("hide")
				down.classList.add("show")
				up.classList.add("hide")
				up.classList.remove("show")
				section.classList.remove("show")
				section.classList.add("hide")
				if (splitter !== null) {
					splitter.classList.remove("hide")
					splitter.classList.add("show")
				}
			}

		},
		getRelevantBenefitsForSu(items) {
			return items.filter(it => it.suBenefit)
		},
		showMoreBenefits(index) {
			const down = document.getElementById('accordionBenefits-' + index + '-down');
			const up = document.getElementById('accordionBenefits-' + index + '-up');
			const section = document.getElementById('accordionBenefits-' + index + '-section');

			if (down.classList !== null && down.classList.contains('show')) {
				// show more
				down.classList.add("hide")
				down.classList.remove("show")
				up.classList.remove("hide")
				up.classList.add("show")
				section.classList.remove("hide")
				section.classList.add("show")
			} else {
				// show less
				down.classList.remove("hide")
				down.classList.add("show")
				up.classList.add("hide")
				up.classList.remove("show")
				section.classList.remove("show")
				section.classList.add("hide")
			}
		},
		resolveVoiceSmsPart(currentTariff) {
			const voice = currentTariff.voicePart.isUnlimited ? this.$t('unlimited') : currentTariff.voicePart.value
			const sms = currentTariff.smsPart.isUnlimited ? this.$t('unlimited') : currentTariff.smsPart.value
			return voice + " + " + sms
		},
		resolveReconciliationUnqualified(item, index) {
			if (item.qualificationResults[0].eligibilityCheckError !== null &&
					item.qualificationResults[0].eligibilityCheckError.code === 'ALREADY_CHANGED_TO_KIWI') {
				if (this.dataStartLoaded[item.subscriberId] === undefined) {
					this.getSubscriberInfo(item, index)
					this.dataStartLoaded[item.subscriberId] = "request ready"
				}
			}
			return item.qualificationResults[0].businessProcess === 'reconciliation' && item.qualificationResults[0].result === 'unqualified'
		},
		resolveTariffQualified(item) {
			return item.qualificationResults[1].businessProcess === 'tariffChange' && item.qualificationResults[1].result === 'qualified'
		},
		resolveReconciliationQualified(item, index) {
			const qualified = item.qualificationResults[0].businessProcess === 'reconciliation' && item.qualificationResults[0].result === 'qualified'
			if (qualified && this.dataStartLoaded[item.subscriberId] === undefined) {
				this.getSubscriberInfo(item, index)
				this.dataStartLoaded[item.subscriberId] = "request ready"
			}
			return qualified
		},
		setEligibilityCheckError(eligibilityCheckError) {
			this.eligibilityCheckErrorLabel = eligibilityCheckError.message
			this.eligibilityCheckErrorReason = eligibilityCheckError.code
		},
		getRecords(from, to) {
			if (this.$store.state.isMigrationDataLoaded) {
				// TODO
				return this.$store.state.transformInfoData.slice(from, to)
			} else {
				return []
			}
		},
		getAllRecords() {
			if (this.$store.state.isMigrationDataLoaded) {
				this.totalOtherTariffs = this.$store.state.transformInfoData.length
				//this.currentPageOtherTariffs = this.totalOtherTariffs
				return this.$store.state.transformInfoData.length
			} else {
				return 0
			}
		},
		getSubscriberInfo(item, index) {
			const body = {
				subscriberId: item.subscriberId,
				msisdn: this.formatMsisdnForBff(item.msisdn),
				qualificationResults: item.qualificationResults
			}
			BffAPI.getSubscriberInfo(this.$store.state.jwt, body)
			.catch(err => console.log(err))
			.finally(() => this.recalculateHeight(item.subscriberId, index))
		},
		recalculateHeight(subscriberId, index) {
			const soucasny_tarif = document.getElementById("soucasny_tarif_el" + index)
			const novy_tarif = document.getElementById("novy_tarif_el" + index)

			if (soucasny_tarif !== null && novy_tarif !== null && soucasny_tarif.offsetHeight > novy_tarif.offsetHeight) {
				novy_tarif.style.height = soucasny_tarif.offsetHeight + "px";
			}
		},
		setDataLoadedForSubscriber() {
			this.$store.state.transformInfoData.forEach(it => this.dataLoadedForSubscriber[it.subscriberId] = it.dataLoaded)
		},
		formatMsisdnForBff(value) {
			value = value.replace('+420', '')
			return value.replace(/\s/g, "")
		},
		resetMap() {
			this.dataLoadedForSubscriber = {}
			this.dataStartLoaded = {}
			this.$store.state.resetMap = false
		}
	},
	computed: {
		showMultiTch() {
			let posibleCount = []
			if (this.$store.state.isMigrationDataLoaded && this.$store.state.transformInfoData !== null) {
				posibleCount = this.$store.state.transformInfoData.filter(it => "qualified" === it.qualificationResults[0].result
						&& "qualified" === it.qualificationResults[1].result && it.newTariffDetail !== null)
			}
			return posibleCount.length > 4
		},
		showCurrentTariff() {
			if (this.$store.state.isMigrationDataLoaded && this.$store.state.basicInfoData !== null) {
				return this.$store.state.showAsIsTariff
			}
			return true
		},
		showPrice() {
			if (this.$store.state.isMigrationDataLoaded && this.$store.state.basicInfoData !== null) {
				return !this.$store.state.basicInfoData.doNotShowPrice
			}
			return true
		},
		isMagentaBusiness() {
			let vseM1 = []
			if (this.$store.state.isMigrationDataLoaded && this.$store.state.transformInfoData !== null && this.$store.state.transformInfoData[0] !== null
					&& this.$store.state.transformInfoData[0].newTariffDetail !== null && this.$store.state.transformInfoData[0].newTariffDetail !== undefined
					&& this.$store.state.transformInfoData[0].newTariffDetail.migrationBenefits !== undefined) {
				vseM1 = this.$store.state.transformInfoData[0].newTariffDetail.migrationBenefits.filter(it => "MAGENTA_B2B" === it.name)
			}

			return vseM1.length > 0;
		},
		existsCaBenefits() {
			let map = []
			if (this.$store.state.isMigrationDataLoaded && this.$store.state.transformInfoData !== null
					&& this.$store.state.transformInfoData[0].qualificationResults[0].eligibilityCheckError !== null
					&& (this.$store.state.transformInfoData[0].qualificationResults[0].eligibilityCheckError.code === 'RESTRICTED_USER_ROLE'
							|| this.$store.state.transformInfoData[0].qualificationResults[0].eligibilityCheckError.code === 'SUSPENDED_SERVICE')) {
				return map
			} else if (this.$store.state.isMigrationDataLoaded && this.$store.state.transformInfoData !== null && this.$store.state.transformInfoData[0] !== null
					&& this.$store.state.transformInfoData[0].newTariffDetail !== null && this.$store.state.transformInfoData[0].newTariffDetail !== undefined
					&& this.$store.state.transformInfoData[0].newTariffDetail.migrationBenefits !== undefined) {
				map = this.$store.state.transformInfoData[0].newTariffDetail.migrationBenefits.filter(it => !it.suBenefit)
			}
			return map
		},
		isMigrationDataLoaded() {
			if (this.$store.state.isMigrationDataLoaded) {
				if (this.$store.state.resetMap) {
					this.resetMap()
				}
				this.setDataLoadedForSubscriber()
			}
			return this.$store.state.isMigrationDataLoaded
		},
		dataError() {
			return this.$store.state.isBasicInfoDataError
		},
		isRelevantUseCase() {
			if (this.$store.state.isMigrationDataLoaded) {
				if (this.$store.state.basicInfoData.eligibilityCheckError === null) {
					return true
				} else {
					this.setEligibilityCheckError(this.$store.state.basicInfoData.eligibilityCheckError)
				}
			}
			return false
		}
	}
}
</script>

<style scoped>

.prave_tlacitko_fix {
	width: fit-content !important;
	margin: 0 auto;
	padding: 6px 60px;
}

.d_s_button_wrapper {
	width: fit-content;
	margin: 0 auto;
}

.d_s_button {
	padding: 0px 19px 0px 19px;
	cursor: pointer;
}

.dalsi_sluzby_message {
	background: #FFF5E8;
	box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	padding: 30px 10px;
	max-width: 858px;
	margin: 30px auto 0;
}

.d_s_text {
	max-width: 1002px;
	margin: 0 auto;
	padding: 9px 16px 20px 16px;
	font-family: "TeleNeoLocalMedium";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 500;
	font-size: 21px;
	line-height: 24px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
}

.d_s_nadpis {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 36px;
	line-height: 41px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
}

.tarify_super_wrapper {
	display: contents;
	max-width: 664px;
	margin: 0 auto;
}

.ca_list_wrapper {
	padding-left: 14px;
	padding-top: 20px;
	padding-bottom: 24px;
}

.ca_list {
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 12px;
}

.ca_item {
	display: grid;
	grid-template-columns: auto 1fr;
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 16px;
	line-height: 18px;
	color: #262626;
}

.ca_item img {
	place-self: center;
}

.ca_item span {
	place-self: center left;
	padding-left: 11px;
}

.m1_wrapper {
	margin: -22px auto 40px auto;
	max-width: 864px;
	display: grid;
	grid-template-columns: auto 1fr;
	padding: 14px 12px 14px 16px;
	background: #FEF2F8;
	box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.15);
	border-radius: 10px;
}

.m1_icon {
	place-self: center;
}

.m1_text_wrapper {
	padding-left: 14px;
}

.m1_nadpis {
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 21px;
	line-height: 24px;
	color: #E20074;
}

.m1_text {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 21px;
	line-height: 24px;
	color: #262626;
}

.info-msg-title {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 24px;
	line-height: 24px;
	text-align: center;
	place-self: center;
}

.info-msg-desc {
	font-size: 21px !important;
	font-weight: 400;
}

.splitter {
	margin: auto;
	width: 40%;
	border-bottom: 1px solid #EBEBEB;
}

.fix-no-tariff-grid {
	grid-template-columns: 1fr !important;
}

.novy_tarif_wrapper-fix {
	grid-column: initial !important;
}

.tarify_super_wrapper-no-current-tariff {
	grid-column: initial;
	grid-template-columns: 1fr;
}

.other-tariffs-section {
	display: grid;
	grid-template-columns: 1fr 61px 30px 61px 1fr;
	padding-bottom: 25px;
	border-bottom: 1px solid #EBEBEB;
}

.stroke-text {
	text-decoration: line-through;
}

.color-magenta {
	color: #e20074 !important;
}

.next-su-title {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 36px;
	line-height: 40px;
	text-align: center;
	place-self: center;
}

.error-title {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 30px;
	line-height: 28px;
	text-align: center;
	place-self: center;
}

.error-desc {
	font-weight: 700;
	font-size: 20px;
	color: #6C6C6C;
	margin-top: 25px;
}

.next-su-desc {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 24px;
	line-height: 27px;
	text-align: center;
	place-self: center;
}

.spinner-custom {
	color: #e20074 !important;
	margin-top: 35px;
	width: 3rem;
	height: 3rem;
	border-width: 2px;
}

.arrow_icon {
	width: 53px;
	height: 53px;
	grid-column: 3;
	margin-top: 10px;
}

.extra_benefity_wrapper {
	padding-top: 20px;
	margin-top: 20px;
	border-top: 1px solid #EBEBEB;
}

.extra_benefity {
	width: 100%;
	text-align: center;
	background: #FEF2F8;
	border-radius: 4px;
	padding: 8px 16px 2px 16px
}

.benefity_icon {
	position: absolute;
	transform: translateX(6px);
}

.benefity_nadpis {
	display: grid;
	grid-template-columns: 23px 1fr;
	width: fit-content;
	margin: 0 auto;
	padding-bottom: 8px;
}

.benefity_nadpis span {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	text-align: center;
	color: #E20074;
}

.benefity_nadpis_icon {
	width: 16px;
	height: 16px;
	margin-right: 6px;
	place-self: center left;
}

.benefity_polozka {
	padding-bottom: 12px;
	position: relative;
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 16px;
	line-height: 18px;
	text-align: center;
	color: #262626;
}

.tarif_nadpis_wrapper {
	grid-column: 1/6;
	display: grid;
	width: 100%;
	border-bottom: 1px solid #EBEBEB;
	padding-bottom: 25px;
}

.zakaznik_wrapper {
	width: fit-content;
	place-self: center;
	display: grid;
	grid-template-columns: 51px 1fr;
}

.zakaznik_icon {
	grid-row: 1/3;
	place-self: center start;
}

.zakaznik_name {
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 24px;
	line-height: 27px;
	color: #262626;
}

.zakaznik_number {
	font-family: "TeleNeoLocalExtraRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 18px;
	line-height: 20px;
	color: #6C6C6C;
}

.upozorneni_wrapper {
	width: 100%;
	grid-column: 1/6;
	padding: 22px 20px 26px 20px;
	margin: 20px 0px 20px 0px;
	display: grid;
	grid-template-columns: 38px 1fr;
	background: #FFF5E8;
	border-radius: 10px;
}

.upozorneni_wrapper_green {
	background-color: #F8FDF3;
}

.upozorneni_icon {
	grid-row: 1/3;
	place-self: center start;
}

.upozorneni_text {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 21px;
	line-height: 20px;
	color: #6C6C6C;
}

.soucasny_tarif_wrapper {
	grid-column: 1;
}

.novy_tarif_wrapper {
	grid-column: 5;
}

.novy_tarif_wrapper .tarif_name {
	color: #e20074;
}

.leve_tlacitko {
	width: 100%;
	grid-column: 1/3;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 21px;
	line-height: 24px;
	text-align: center;
	letter-spacing: -0.3px;
	height: 45px;
	border: 1px solid #E20074;
	color: #E20074;
}

.send-again-btn {
	font-family: "TeleNeoLocalRegular" !important;
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	margin-top: 35px;
	width: 50% !important;
	display: inline-grid;
}

.prave_tlacitko {
	width: 100%;
	grid-column: 1/6;
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 21px;
	line-height: 24px;
	text-align: center;
	letter-spacing: -0.3px;
	height: 45px;
	background-color: #e20074;
	color: #FFFFFF;
}

.background-white {
	max-width: 1270px;
	margin: 0 auto;
	padding: 24px 303px 40px 303px;
	display: grid;
	grid-template-columns: 1fr 61px 30px 61px 1fr;
}

.background-white-no-current-tariff {
	display: block;
	grid-template-columns: none;
}

.tarif_name {
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 24px;
	line-height: 27px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #6C6C6C;
	border-bottom: 1px solid #EBEBEB;
	padding-top: 24px;
	padding-bottom: 20px;
}

.tarif_data {
	display: grid;
	align-items: center;
	font-family: "TeleNeoLocalExtraBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 800;
	font-size: 24px;
	line-height: 27px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #262626;
	border-bottom: 1px solid #EBEBEB;
	padding-top: 24px;
	padding-bottom: 20px;
}

.tarif_data_detail_wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	border-bottom: 1px solid #EBEBEB;
	padding-top: 24px;
	padding-bottom: 20px;
}

.tarif_data_detail_nadpis {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	text-align: center;
	color: #6C6C6C;
	place-self: center;
}

.tarif_data_detail_value {
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 16px;
	line-height: 20px;
	text-align: center;
	color: #262626;
	place-self: center;
}

.tarif_cena {
	font-family: "TeleNeoLocalBold";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 700;
	font-size: 30px;
	line-height: 34px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #E20074;
	place-self: center;
	padding-top: 24px;
}

.tarif_cena_obdobi {
	font-family: "TeleNeoLocalRegular";
	-webkit-font-smoothing: antialiased !important;
	text-rendering: optimizeLegibility !important;
	font-weight: 400;
	font-size: 21px;
	line-height: 26px;
	text-align: center;
	letter-spacing: -0.3px;
	color: #6C6C6C;
	place-self: center;
}

@media only screen and (max-width: 770px) {

	.dalsi_sluzby_message {
		padding-bottom: 35px;
		padding-top: 20px;
	}

	.tarify_super_wrapper {
		display: grid !important;
		grid-template-columns: 1fr 1fr !important;
		grid-column: 1/3 !important;
	}

	.tarify_super_wrapper-no-current-tariff {
		display: block !important;
		grid-template-columns: none;
	}

	.tarif_wrapper {

	}

	.magenta_area {
		margin-top: 50px !important;
	}

	.zakaznik_wrapper {
		padding-left: 20px;
	}

	.arrow_icon {
		position: absolute;
		width: 25px;
		height: 25px;
		top: 100px;
		left: calc(50% - 12px);
	}

	.zakaznik_wrapper {
		place-self: center start;
	}

	.novy_tarif_wrapper {
		grid-column: 2;
	}

	.background-white {
		width: 100%;
		padding-left: 0px !important;
		padding-right: 0px !important;
		grid-template-columns: 50% 50%;
	}

	.leve_tlacitko, .prave_tlacitko, .upozorneni_wrapper {
		width: calc(100% - 32px) !important;
		margin-left: 16px;
		margin-right: 16px;
		grid-column: 1/3;
	}

	.prave_tlacitko {
		margin-top: 12px;
	}

	.extra_benefity_wrapper {
		padding-left: 16px;
		padding-right: 16px;
	}

	.tarif_data_detail_wrapper {
		grid-template-columns: 1fr;
		padding-top: 16px;
		padding-bottom: 16px;
	}

	.detail_polozka:first-child {
		padding-bottom: 16px;
	}

	.detail_polozka:last-child {
		padding-top: 16px;
		border-top: 1px solid #EBEBEB;
	}

	@supports (-webkit-touch-callout: none) {
		/* CSS specific to iOS devices */
		.ca_item, .m1_nadpis, .m1_text, .info-msg-title, .next-su-title, .error-title, .next-su-desc, .benefity_polozka, .zakaznik_name, .zakaznik_number, .upozorneni_text, .leve_tlacitko, .send-again-btn, .prave_tlacitko, .tarif_name, .tarif_data, .tarif_data_detail_nadpis, .tarif_data_detail_value, .tarif_cena, .tarif_cena_obdobi {
			letter-spacing: -0.05rem !important;
		}

		.benefity_nadpis span {
			letter-spacing: -0.05rem !important;
		}
	}
}

@media only screen and (max-width: 1300px) {
	.background-white {
		padding-right: 94px;
		padding-left: 94px;
	}
}
</style>
